import { homeCalloutList } from "../../Constants/callouts"

export const getHomeFullImageCallout = (location: string) => {
    const liveCallout = homeCalloutList.find((callout) => callout.location === location)

    if(!liveCallout) return homeCalloutList[0]
    return liveCallout

}